const isProduction = () => process.env.NODE_ENV === 'production';
const prefix = 'Invariant failed';

type Invariant = (condition?: unknown, message?: string | (() => string)) => asserts condition;

export const getEnvVariableMessage = (key: string) => `Please fill ${key} in .env file`;

export const invariant: Invariant = (condition, message) => {
    if (condition) {
        return;
    }

    // if (isProduction()) {
    //     throw new Error(prefix);
    // }

    const provided: string | undefined = typeof message === 'function' ? message() : message;

    const value: string = provided ? `${prefix}: ${provided}` : prefix;

    throw new Error(value);
};

export const invariantEnvKeys = (keys: string[]) => {
    const keyErrors: string[] = [];

    keys.forEach(key => {
        try {
            invariant(process.env[key], () => getEnvVariableMessage(key));
        } catch {
            keyErrors.push(key);
        }
    });

    if (keyErrors.length > 0) {
        if (isProduction()) {
            throw new Error(prefix);
        }

        const joinedKeys = keyErrors.length === 1 ? keyErrors[0] : keyErrors.join(', ');
        const message = `${prefix}: Please fill ${joinedKeys} in .env file`;

        throw new Error(message);
    }
};
